import { useOrgContext } from "../../app/orgContext.js";
import { OrgProfileForm } from "./OrgProfileForm.js";
import styles from "./OrgSettingsScreen.module.scss";

/**
 * Organization tab — the org profile editor (name / contact email / logo; `org_type` is org identity and
 * renders read-only, immutable post-create).
 *
 * Rendered only where `roster:manage_seats` holds — see `orgSettingsTabs.ts`. The body itself carries no
 * second gate: the tab list is the one place that decision lives, so the page and the modal cannot disagree
 * about who sees it.
 */
export function OrgSettingsOrganizationTab() {
  const { orgId } = useOrgContext();
  return (
    <section aria-labelledby="org-profile-heading">
      <h3 id="org-profile-heading" className={styles.groupLabel}>
        Organization
      </h3>
      <OrgProfileForm orgId={orgId} />
    </section>
  );
}
